/* Cart drawer eBook upsell card (Dad eBook collection). Replaces the old tick-box bump and takes the
 * place of the generic "Add to my order" recommendation card. Never pre-ticked: adds only on click.
 * Hidden when the eBook is already in the cart. Loaded before ywr-cart-drawer.js. */
(function () {
  var node = document.querySelector('[data-ywr-bump]');
  if (!node) return;
  var button = node.querySelector('[data-ywr-bump-add]');
  var errorNode = node.querySelector('[data-ywr-bump-error]');
  var variantId = String(node.dataset.variantId);
  var offerIds = (node.dataset.offerIds || '').split(',').filter(Boolean);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // 'You Will Rock eBook Library' variants ($37 / $69 / $90): same six eBooks. Never let both products sit in one cart.
  var LIBRARY = ['67590874169437','67590874202205','67590874234973'];
  function isLibrary(item) { return LIBRARY.indexOf(String(item.variant_id || item.id)) >= 0; }
  var busy = false, visible = false, hasComplete = false, lastCartAt = 0, lastCart = null;
  function protectionId() { var p = document.querySelector('[data-ywr-protection]'); return p ? String(p.dataset.variantId) : ''; }
  function isEbook(item) { return String(item.variant_id || item.id) === variantId; }
  function hasOther(cart) {
    var pid = protectionId();
    return !!cart && Array.isArray(cart.items) && cart.items.some(function (i) { return i.quantity > 0 && String(i.variant_id) !== pid && !isEbook(i); });
  }
  function paint(cart) {
    lastCartAt = Date.now(); lastCart = cart;
    var inCart = cart.items.some(function (i) { return (isEbook(i) || isLibrary(i)) && i.quantity > 0; });
    hasComplete = cart.items.some(function (i) { return isEbook(i) && i.quantity > 0; });
    visible = hasOther(cart) && !inCart;
    node.hidden = !visible;
  }
  // While the eBook card shows, it replaces the generic recommendation card; the eBook is never offered twice.
  var engine = window.YWRCartOffers;
  if (engine && typeof engine.recommend === 'function' && !engine.__ywrBump) {
    var recommend = engine.recommend;
    engine.recommend = function (cart) {
      var list = recommend.apply(this, arguments);
      try { paint(cart); } catch (_) {}
      if (!Array.isArray(list)) return list;
      if (visible) return [];
      return list.filter(function (o) {
        if (offerIds.indexOf(o.id) >= 0) return false;
        // Complete Collection in the cart: drop every eBook Library offer and its upgrade flow ('Hold one too', 'Add the paperbacks, +$32').
        if (hasComplete && (/^ebook-(37|69|90)$/.test(o.flowId || '') || (o.add || []).some(isLibrary))) return false;
        return !(o.add || []).some(function (a) { return String(a.id) === variantId; });
      });
    };
    engine.__ywrBump = true;
  }
  document.addEventListener('ywr:cart-updated', function () {
    if (Date.now() - lastCartAt < 100) return;
    fetch(root + 'cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}})
      .then(function (r) { return r.json(); }).then(paint).catch(function () {});
  });
  // A dropped connection (WebKit: "Load failed") shows one plain line, never the browser's text.
  var NETWORK = 'Connection hiccup. Tap to try again.';
  async function post(path, body) {
    var res = await fetch(root + path, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
    if (!res.ok) { var j = {}; try { j = await res.json(); } catch (_) {} var err = new Error(j.description || 'We couldn\u2019t update your cart. Please try again.'); err.shopify = true; throw err; }
    return res.json();
  }
  button.addEventListener('click', async function () {
    if (busy) return;
    busy = true; button.disabled = true; errorNode.hidden = true;
    var drawer = window.YWRCartDrawer;
    try {
      if (drawer && drawer.idle) await drawer.idle();
      for (var i = 0; i < 100 && drawer && drawer.isBusy && drawer.isBusy(); i++) await new Promise(function (r) { setTimeout(r, 50); });
      var cart = await (await fetch(root + 'cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}})).json();
      if (!cart.items.some(isEbook) && !cart.items.some(isLibrary)) {
        await post('cart/add.js', {items: [{id: Number(variantId), quantity: 1, properties: {_ywr_cart_offer: 'cart-ebook-50'}}]});
        try { if (window.YWREbookAttr) window.YWREbookAttr.added('cart card'); } catch (_) {} // after a confirmed add (post throws on failure)
      }
    } catch (e) {
      errorNode.textContent = e.shopify ? e.message : NETWORK; errorNode.hidden = false;
    } finally {
      busy = false; button.disabled = false;
      try { if (drawer && drawer.refresh) await drawer.refresh(true); } catch (_) {}
    }
  });
})();
